// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"23":"agenda","177":"home","914":"publishers","963":"event"}[chunkId] + "-legacy." + {"23":"19d0b858","177":"c06db88b","914":"46e039b3","963":"2c4bc9a7"}[chunkId] + ".js";
};